import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RatingModule } from 'primeng/rating';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToolbarModule } from 'primeng/toolbar';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { Popover } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { StepsModule } from 'primeng/steps';
import { DataViewModule } from 'primeng/dataview';
import { BadgeModule } from 'primeng/badge';
import { DatePicker } from 'primeng/datepicker';
import { Textarea } from 'primeng/textarea';
import { BlockUIModule } from 'primeng/blockui';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SkeletonModule } from 'primeng/skeleton';
import { GalleriaModule } from 'primeng/galleria';
import { CarouselModule } from 'primeng/carousel';
import { AccordionModule } from 'primeng/accordion';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TableModule,
    RatingModule,
    ButtonModule,
    ToastModule,
    InputNumberModule,
    ConfirmDialogModule,
    FileUploadModule,
    RadioButtonModule,
    ToolbarModule,
    Select,
    FormsModule,
    DialogModule,
    InputTextModule,
    CardModule,
    PasswordModule,
    MessageModule,
    ProgressSpinnerModule,
    MultiSelectModule,
    Popover,
    TooltipModule,
    DividerModule,
    StepsModule,
    DataViewModule,
    BadgeModule,
    DatePicker,
    Textarea,
    BlockUIModule,
    CheckboxModule,
    SkeletonModule,
    GalleriaModule,
    CarouselModule,
    AccordionModule,
    DynamicDialogModule,
    IconFieldModule,
    InputIconModule,
  ],
  exports: [
    RatingModule,
    ButtonModule,
    ToastModule,
    InputNumberModule,
    ConfirmDialogModule,
    FileUploadModule,
    RadioButtonModule,
    ToolbarModule,
    Select,
    FormsModule,
    DialogModule,
    InputTextModule,
    CardModule,
    PasswordModule,
    MessageModule,
    ProgressSpinnerModule,
    TableModule,
    MultiSelectModule,
    Popover,
    TooltipModule,
    DividerModule,
    StepsModule,
    DataViewModule,
    BadgeModule,
    DatePicker,
    Textarea,
    BlockUIModule,
    CheckboxModule,
    AutoCompleteModule,
    SkeletonModule,
    GalleriaModule,
    CarouselModule,
    AccordionModule,
    DynamicDialogModule,
    IconFieldModule,
    InputIconModule,
  ],
})
export class PrimengModule {}
